import { CurriculumModule } from "./types";

export default function RoadmapEndTrophy({ modules }: { modules: CurriculumModule[] }) {
  const remainingLockedNames = modules
    .filter((m) => m.status === "locked")
    .slice(0, 3)
    .map((m) => m.name);

  return (
    <div
      className="mt-6 text-center p-4 rounded-2xl border border-dashed border-white/10"
      style={{ background: "linear-gradient(135deg, rgba(113,208,0,0.05), rgba(0,102,200,0.05))" }}
    >
      <div className="text-3xl">🏆</div>
      <div className="text-white font-semibold mt-1">Bitirme Projesi</div>
      <div className="text-white/40 text-xs mt-1">
        {remainingLockedNames.length > 0
          ? `${remainingLockedNames.join(", ")} ve daha fazlası yolda`
          : "Yolculuğun sonuna geldin!"}
      </div>
    </div>
  );
}
